import script from "./EndOfLifeCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EndOfLifeCard.vue?vue&type=script&setup=true&lang=ts"

import "./EndOfLifeCard.vue?vue&type=style&index=0&id=3e4d847c&lang=scss&scoped=true"
import "./EndOfLifeCard.vue?vue&type=style&index=1&id=3e4d847c&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e4d847c"]])

export default __exports__